function Right(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M22.172 25l-1.156-1.328-11-12.5L7 13.828 16.828 25 7 36.172l3.016 2.656 11-12.5L22.172 25z"
          fill="#4079F5"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="rotate(-90 25 25)" d="M0 0h50v30H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Right
